<template>
<div class="calculation_area my-2 px-2 pb-2 ">	


<!--controls-->

<div class="calculation_controls">



<Button label="İptal"   v-if="adding_variable || adding_operator" class=" p-button-danger p-button-outlined  p-button-sm mr-2" @click="cancelAdding"></Button>
<Button label="Yeni Değişken Ekle" v-if="!adding_variable" class=" p-button-primary p-button-outlined  p-button-sm" @click="addVariable"></Button>

<Button label="Yeni Operatör Ekle" v-if="!adding_operator" class=" p-button-primary p-button-outlined  p-button-sm ml-2" @click="addOperator"></Button>


<!--add variable-->
<template v-if="adding_variable">
<Dropdown :filter="true"  v-model="selectedquestionlist" :options="questionlists" optionLabel="name" optionValue="id" class="ml-2 p-inputtext-sm" @change="questionlistSelected"/>

<Dropdown :filter="true" v-if="selectedquestionlist" v-model="selectedperiod" :options="periods" optionLabel="name" optionValue="id" class="ml-2 p-inputtext-sm" :loading="loading_periods"  @change="periodSelected"/>

<Dropdown :filter="true" v-if="selectedperiod" v-model="selectedinputfield" :options="inputfields" optionLabel="shortname" optionValue="id" class="ml-2 p-inputtext-sm" :loading="loading_inputfields"  @change="inputfieldSelected"/>

<Dropdown :filter="true" v-if="selectedinputfield" v-model="selectedcolumn" :options="columns" optionLabel="shortname" optionValue="id" class="ml-2 p-inputtext-sm" :loading="loading_columns"  @change="columnSelected"/>
</template>
<!--add variable-->


<!--add operator-->
<template v-if="adding_operator">
<Dropdown   v-model="selectedoperator" :options="operators" optionLabel="name" optionValue="code" class="ml-2 p-inputtext-sm" @change="operatorSelected"/>
</template>
<!--add operator-->



</div>

<!--controls-->

<CalculationStage :nodes="$store.state.calculations.nodes" :connections="$store.state.calculations.connections"></CalculationStage>

</div>
</template>

<script>
import CalculationStage from "./CalculationStage"
 
export default {

  name: 'CalculationRoot',
  props:["questionlists","nodesdata"],
  components:{CalculationStage},
  data () {
    return {
    	periods:[],
    	nodes:[],
    	connections:[],
    	node:{
			id:null,
			title:null,
			queue:null,
			period_id:null,
			inputfield_id:null,
			column_id:null,
			offsetX:10,
			offsetY:10,
			type:null,
			output:null,
			input1:null,
			input2:null,
		},
		connection:{
			id:null,
			x1:null,
			y1:null,
			x2:null,
			y2:null,
			from:null,
			to:null,
			drawing:true,
		},
		operators:[
		{name:"Toplama",code:"addition"},
		{name:"Çıkarma",code:"subtraction"},
		{name:"Çarpma",code:"multiplication"},
		{name:"Bölme",code:"division"},
		{name:"Eşittir",code:"equation"},
		],
		container:null,
		currentX:0,
  	currentY:0,
  	initialX:0,
  	initialY:0,
  	xOffset:0,
  	yOffset:0,
  	drag_active:false,
  	draw_active:false,
  	dragged_element:null,
  	adding_item:false,
  	adding_variable:false,
  	adding_operator:false,
		selectedquestionlist:null,
		selectedperiod:null,
		selectedinputfield:null,
		selectedcolumn:null,
		selectedoperator:null,
    inputfields:[],
    columns:[],
    loading_periods:true,
    loading_inputfields:true,
    loading_columns:true,
    }
  },
  computed:{
  	nodemoved()
  	{
  		return this.$store.state.calculations.nodedragging
  	},
  	connectioncreated()
  	{
  		return this.$store.state.calculations.connectioncreated
  	},
  },
  watch:{
  	nodemoved(newval)
  	{  		
  		if(!newval)
  		{

  		}
  	},
  	connectioncreated(newval)
  	{  		

  		if(newval)
  		{
  			console.log("connectioncreated")

  			
  		}
  	}
  },
  mounted()
  {
  	this.$store.state.calculations.stagezoom = 1
  	this.$store.dispatch('calculations/setNodes',[])
  	this.$store.dispatch('calculations/setConnections',[])
  	this.$store.dispatch('calculations/setSelectedConnection',null)
  	this.container = document.querySelector("#calculation_stage");

  	this.container.addEventListener("touchstart", this.dragStart, false);
    this.container.addEventListener("touchend", this.dragEnd, false);
    this.container.addEventListener("touchmove", this.drag, false);
    this.container.addEventListener("mouseover", this.pointerenter, false);

    
  	this.container.addEventListener("mousedown", this.dragStart, false);
    this.container.addEventListener("mouseup", this.dragEnd, false);
    this.container.addEventListener("mousemove", this.drag, false);
    this.container.addEventListener("mouseover", this.overNotch, false);
    this.container.addEventListener("wheel", this.zoomStage, false);
    
	if(this.nodesdata)
  	{
  		let nodesdata = JSON.parse(this.nodesdata)
  		console.log(nodesdata)
  		this.$store.dispatch('calculations/setNodes',nodesdata.nodes)
  		this.$store.dispatch('calculations/setConnections',nodesdata.connections)
  	}

  },
  methods:{
  	async getProjectPeriods()
  	{ 
  		this.loading_periods = true
  		this.periods = await this.generalApiGetWithoutLoader("projectperiod_by_question_list/"+this.selectedquestionlist)
  		console.log(this.periods)
  		this.loading_periods = false
  	},
  	async periodSelected()
    {
      await this.getInputfields()
    },
    async questionlistSelected()
    {
      console.log(this.selectedquestionlist)

      await this.getProjectPeriods()
    },
    async getInputfields()
    {
    	console.log(this.selectedquestionlist)
    	console.log(this.selectedperiod)
    	this.loading_inputfields = true
      //let inputfields = await this.generalApiGetWithoutLoader("questionlists/inputfields_for_calculation/"+this.selectedquestionlist)
      let inputfields = await this.generalApiGetWithoutLoader("questionlists/all_inputfield_versions/"+this.selectedquestionlist+"/"+this.selectedperiod)
      console.log("inputfields")
      console.log(inputfields)
      for(let inputfield of inputfields)
      {
      	inputfield.shortname = inputfield.name                  
      }

      this.inputfields  = await inputfields
      this.loading_inputfields = false
    },
    async inputfieldSelected()
    {
      let inputfield = this.inputfields.find((item)=>{return item.id == this.selectedinputfield})
      if(inputfield.type=="columns")
      {
        this.loading_columns = await true
        let columns = await this.generalApiGetWithoutLoader("questionlists/inputfield_columns_for_calculation/"+this.selectedinputfield)
        for(let column of columns)
        {
            if(column.name.length>30)
            {
                column.shortname = await column.name.substring(0, 30);
            }
            else
            {
            	 column.shortname = await  column.name
            }
            
        }
        this.columns  = await columns
        this.loading_columns = await false
      }
      else
      {
       	await this.addVariableNode(inputfield)
      }
      
    },
    columnSelected()
    {
      let column = this.columns.find((item)=>{return item.id == this.selectedcolumn})
      let inputfield = this.inputfields.find((item)=>{return item.id == this.selectedinputfield})

      this.addVariableNode(inputfield,column)

    },
    operatorSelected()
    {
    	let operator = this.operators.find((item)=>{return item.code == this.selectedoperator})
    	let node = this.sanitizeArray(this.node)
  		node.id =  Math.floor(Date.now() / 10)
  		node.title =  Math.floor(Date.now() / 10)
  		node.offsetX = 10
  		node.offsetY = 10
  		node.title = operator.name
  		node.type=this.selectedoperator
  		
  		let nodes = this.$store.state.calculations.nodes
  		nodes.push(node)
  		this.$store.dispatch('calculations/setNodes',nodes)

        this.cancelAdding()

    },
    addVariableNode(inputfield,column)
    {
    	let period = this.periods.find((item)=>{return item.id == this.selectedperiod})
    	let node = this.sanitizeArray(this.node)
  		node.id =  Math.floor(Date.now() / 10)
  		node.title =  Math.floor(Date.now() / 10)
  		node.offsetX = 10
  		node.offsetY = 10
  		node.title = inputfield.name
  		node.type="variable"
  		node.questionlist_id = this.selectedinputfield
  		node.inputfield_id = this.selectedinputfield
  		node.period_id = this.selectedperiod
  		node.period_name = period.name
  		if(column)
  		{
  			node.column_id = column.id
  			node.title = inputfield.name + "-"+column.name
  		}
  		let nodes = this.$store.state.calculations.nodes
  		nodes.push(node)
  		this.$store.dispatch('calculations/setNodes',nodes)

        this.cancelAdding()
    },

    addVariable()
    {
      this.adding_variable = true
      this.adding_operator = false
    },    
    cancelAdding()
    {
      this.selectedinputfield = null
      this.selectedquestionlist = null
      this.selectedcolumn = null
      this.adding_variable = false
      this.selectedoperator = null
      this.adding_operator = false
    },

    addOperator()
    {
      this.adding_operator = true
      this.adding_variable = false
    },    
    cancelOperator()
    {
      
    },
  	dragStart(e)
  	{
  		//node drag start
  		console.log(this.$store.state.calculations.nodes)
  		console.log(this.$store.state.calculations.connections)
  		let zoom = this.$store.state.calculations.stagezoom
  		if(e.target.classList.contains("calculation_node_header_text"))
  		{
  			let target_id = e.target.id.replace("handle","node")
  			let node_id = e.target.id.replace("handle","")
  			
        	let selected_node_ind = this.$store.state.calculations.nodes.findIndex((item)=>{return item.id == node_id})
        	this.$store.dispatch('calculations/setSelectedNode',this.$store.state.calculations.nodes[selected_node_ind])
        	this.dragged_element = document.getElementById(target_id)  			
        	this.drag_active = true
  		}
  		//right node drag start
  		if(e.target.classList.contains("calculation_node_right_notch"))
  		{
  			let from_id = e.target.id.replace("right_notch","")
  			let bounds = this.container.getBoundingClientRect();
      	 	let initialX = e.clientX - bounds.left
	     	let initialY = e.clientY - bounds.top
	     	let connection = this.sanitizeArray(this.connection)
	  		connection.id =  Math.floor(Date.now() / 10)
	  		connection.x1 = (initialX)/zoom;
      		connection.y1 = (initialY)/zoom;
      		connection.x2 = (initialX)/zoom;
      		connection.y2 = (initialY)/zoom;
      		connection.from = from_id
      		let connections = this.$store.state.calculations.connections
      		connections.push(connection)
      		this.$store.dispatch('calculations/setConnections',connections)
      		this.$store.dispatch('calculations/setSelectedConnection',connection)
      		let fromnode_ind = this.$store.state.calculations.nodes.findIndex((item)=>{return item.id == from_id})
      		this.$store.dispatch('calculations/setFromNode',this.$store.state.calculations.nodes[fromnode_ind])




  			this.draw_active = true
  		}

  		//right node drag start

  	},
  	dragEnd(e)
  	{
        this.drag_active = false;
        if(this.draw_active)
        {
        	let selectedconnection = this.$store.state.calculations.selectedconnection
	        let connections = this.$store.state.calculations.connections
	        connections = connections.filter((item)=>{return item.id !== selectedconnection.id})
	        this.$store.dispatch('calculations/setConnections',connections)
        	this.draw_active = false;
        }
        

  	},
  	drag(e)
  	{
  		let zoom = this.$store.state.calculations.stagezoom
  		if (this.drag_active) {
  			e.preventDefault();
  			let selectednode = this.$store.state.calculations.selectednode
  			let bounds = this.container.getBoundingClientRect();
  			selectednode.offsetX = (e.clientX - bounds.left - (90*zoom))/zoom
  			selectednode.offsetY = (e.clientY - bounds.top - (18*zoom))/zoom
  			let nodes = this.$store.state.calculations.nodes
  			let ind = nodes.findIndex((item)=>{return item.id ==selectednode.id})
  			nodes[ind] = selectednode
  			this.$store.dispatch('calculations/setNodes',nodes)

  			/*
  			this.currentX = e.clientX - this.initialX;
	        this.currentY = e.clientY - this.initialY;
	        this.xOffset = this.currentX;
	        this.yOffset = this.currentY;
	        */
	        //this.setTranslate(this.currentX, this.currentY, this.dragged_element);
	        this.updateConnectionNotches(selectednode.offsetX,selectednode.offsetY,selectednode.id);

  		}
  		if (this.draw_active) {
  			let bounds = this.container.getBoundingClientRect();
  			let currentX = e.clientX - bounds.left
	        let currentY = e.clientY - bounds.top
	        let active_connection = this.$store.state.calculations.selectedconnection
      		//console.log(active_connection)
      		active_connection.x2 = (currentX)/zoom;
      		active_connection.y2 = (currentY)/zoom;
      		let connections = this.$store.state.calculations.connections
      		let ind = connections.findIndex((item)=>{return  item.id == active_connection.id})
      		connections[ind] = active_connection
      		this.$store.dispatch('calculations/setConnections',connections)
      		let from_node = this.$store.state.calculations.nodes.find((item)=>{return item.id == active_connection.from})

      		this.updateConnectionNotches(from_node.offsetX,from_node.offsetY,from_node.id);

  		}

  	},
  	setTranslate(xPos, yPos, el) {
      el.style.transform = "translate3d(" + xPos + "px, " + yPos + "px, 0)";
    },
    updateConnectionNotches(xPos,yPos,node_id)
    {
    	//let node = this.$store.state.calculations.nodes.find((item)=>{return item.id == node_id})
    	let from_connections = this.$store.state.calculations.connections.filter((item)=>{return item.from == node_id})
    	let to_connections = this.$store.state.calculations.connections.filter((item)=>{return item.to == node_id})
    	for(let con of from_connections)
    	{
    		con.x1 = xPos+193
    		con.y1 = yPos+18
    		con.drawing = false
    	}
    	for(let con of to_connections)
    	{
    		con.x2 = xPos -8
    		con.y2 = yPos +18
    		con.drawing = false
    	}
    },
  	overNotch(e)
  	{
  		let zoom = this.$store.state.calculations.stagezoom
  		if(e.target.classList.contains("calculation_node_left_notch") && this.draw_active)
  		{
  			let to_id = e.target.id.replace("left_notch","")

  			let target_node = this.$store.state.calculations.nodes.find((item)=>{return item.id == to_id})
  			if(target_node.input1 && target_node.input2)
  			{
  				this.showMessage("error","Bir hesaplama öğesine en fazla iki değişken iliştirilebilir","")
  				let selectedconnection = this.$store.state.calculations.selectedconnection
		        let connections = this.$store.state.calculations.connections
		        connections = connections.filter((item)=>{return item.id !== selectedconnection.id})
		        this.$store.dispatch('calculations/setConnections',connections)
	        	this.draw_active = false;
  				return  false
  			}
  			else
  			{

  				let element = document.getElementById(e.target.id)
	  			let selectedconnection = this.$store.state.calculations.selectedconnection
	  			let bounds = this.container.getBoundingClientRect();
	  			console.log(selectedconnection)
	  			selectedconnection.x2 = (e.clientX - bounds.left +8)/zoom
	  			selectedconnection.y2 = (e.clientY - bounds.top +8)/zoom
	  			selectedconnection.to = to_id
	  			let connections = this.$store.state.calculations.connections
	  			let ind = connections.findIndex((item)=>{return item.id == selectedconnection.id})
	  			connections[ind] = selectedconnection
	  			this.$store.dispatch('calculations/setConnections',connections)

	  			//set node input
	  			let input_item = {connection_id:selectedconnection.id,type:"connection"}
	  			//target_node.input.push(input_item) 
	  			if(target_node.input1 && !target_node.input2)
	  			{
	  				target_node.input2 = input_item
	  			}

	  			if(!target_node.input1 && target_node.input2)
	  			{
	  				target_node.input1 = input_item
	  			}

	  			if(!target_node.input1 && !target_node.input2)
	  			{
	  				target_node.input1 = input_item
	  			}



	  			let target_ind = this.$store.state.calculations.nodes.findIndex((item)=>{return item.id == to_id})
	  			this.$store.state.calculations.nodes[target_ind] = target_node
	  			//set node input
	  			//set node output
	  			let from_node_ind = this.$store.state.calculations.nodes.findIndex((item)=>{return item.id == selectedconnection.from})
	  			//this.$store.state.calculations.nodes[from_node_ind].output = selectedconnection.id
	  			//set node output



	  			this.draw_active = false;
	  			this.updateConnectionNotches(this.$store.state.calculations.nodes[target_ind].offsetX,this.$store.state.calculations.nodes[target_ind].offsetY,this.$store.state.calculations.nodes[target_ind].id);

  			}

  			
  		}
  		
  	},
  	zoomStage(e)
  	{
  		console.log("zoom")
  		e.preventDefault()
  		if(this.$store.state.calculations.stagezoom<1.5 && this.$store.state.calculations.stagezoom>0.5)
	  	{
	  		if(e.deltaY<0)
	  		{
	  			this.$store.state.calculations.stagezoom += 0.1
	  		}
	  		if(e.deltaY>0)
	  		{
	  			this.$store.state.calculations.stagezoom -= 0.1
	  		}
  		}
  		if(this.$store.state.calculations.stagezoom>1.5)
  		{
  			if(e.deltaY>0)
	  		{
	  			this.$store.state.calculations.stagezoom -= 0.1
	  		}
  		}

  		if(this.$store.state.calculations.stagezoom<0.5)
  		{
  			if(e.deltaY<0)
	  		{
	  			this.$store.state.calculations.stagezoom += 0.1
	  		}
  		}
  		

  	}
  }
}
</script>

<style lang="css" scoped>
</style>